import { Handshake, Headphones, Mail, Music2 } from 'lucide-react';

const labelOpportunities = [
  {
    icon: Music2,
    title: 'Curated Music Distribution',
    description: 'Learn how PrimeTime selects and organizes music for working DJs and VJs.'
  },
  {
    icon: Headphones,
    title: 'Reach Working DJs',
    description: 'Explore opportunities to make your releases available to DJs preparing sets for events and venues.'
  },
  {
    icon: Handshake,
    title: 'Label Partnerships',
    description: 'Discuss catalog partnerships, permissions, and music submissions directly with our team.'
  }
];

export function ForLabels() {
  return (
    <section className="relative isolate overflow-hidden bg-black">
      <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true">
        <div className="absolute -left-24 -top-28 h-80 w-80 rounded-full bg-prime-red/20 blur-3xl" />
        <div className="absolute -right-24 -top-28 h-80 w-80 rounded-full bg-prime-red/15 blur-3xl" />
        <div className="absolute -bottom-48 left-1/2 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-prime-red/10 blur-3xl" />
      </div>

      <div className="container-shell py-12 sm:py-16 lg:py-20">
        <div className="mx-auto max-w-5xl text-center">
          <img
            src="/img/logo-primetime2.png"
            alt="PrimeTime DJ Pool"
            className="mx-auto h-24 w-72 object-cover object-center sm:h-28 sm:w-[26rem]"
          />
          <p className="mt-5 text-sm font-black uppercase tracking-[0.35em] text-prime-red">FOR LABELS &amp; ARTISTS</p>
          <h1 className="mx-auto mt-5 max-w-5xl text-5xl font-black leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-7xl">
            <span className="block">Get Your Music Into</span>
            <span className="block">the Right DJ Sets.</span>
          </h1>
          <div className="mx-auto mt-5 h-1 w-48 -skew-x-12 rounded-full bg-prime-red shadow-glow" aria-hidden="true" />
          <p className="mx-auto mt-6 max-w-3xl text-base leading-7 text-white/65 sm:text-lg">
            Connect with PrimeTime DJ Pool to explore opportunities for your music in our professionally curated DJ/VJ catalog.
          </p>
        </div>

      <div className="mx-auto mt-12 grid max-w-6xl items-stretch gap-5 md:grid-cols-3 lg:mt-14">
        {labelOpportunities.map(({ icon: Icon, title, description }) => (
          <article key={title} className="flex h-full flex-col items-center rounded-3xl border border-prime-red/30 bg-black/60 p-7 text-center shadow-[inset_0_-28px_48px_rgba(229,9,20,0.08)] sm:p-8">
            <div className="flex h-20 w-20 items-center justify-center rounded-2xl border border-prime-red/60 bg-prime-red/10 text-prime-red shadow-[0_0_28px_rgba(229,9,20,0.25)]">
              <Icon aria-hidden="true" size={34} strokeWidth={2.25} />
            </div>
            <h2 className="mt-6 text-xl font-black leading-tight text-white">{title}</h2>
            <p className="mt-4 max-w-xs text-sm leading-6 text-white/65">{description}</p>
          </article>
        ))}
      </div>

      <div className="mx-auto mt-12 max-w-2xl rounded-3xl border border-prime-red/60 bg-black/70 p-8 text-center shadow-[0_0_40px_rgba(229,9,20,0.18)] sm:mt-14 sm:p-10">
        <h2 className="text-2xl font-black text-white sm:text-3xl">Interested in working with PrimeTime?</h2>
        <p className="mt-3 text-white/65">Reach our label relations team.</p>
        <a
          href="mailto:labels@primetimedjpool.com"
          className="mt-5 inline-flex items-center justify-center gap-3 text-lg font-black text-prime-red transition-colors hover:text-red-400 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-prime-red/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black sm:text-xl"
        >
          <Mail aria-hidden="true" size={24} strokeWidth={2.25} />
          labels@primetimedjpool.com
        </a>
      </div>
      </div>
    </section>
  );
}
